var map = {
	"./breakfast.svg": "b2c9",
	"./commute-to-home.svg": "e3d9",
	"./commute-to-university.svg": "7891",
	"./diner.svg": "a144",
	"./eating-out.svg": "95a9",
	"./gaming.svg": "baec",
	"./going-out.svg": "9839",
	"./live-event.svg": "5c92",
	"./lunch.svg": "046e",
	"./me-time.svg": "32a1",
	"./on-the-move.svg": "aae5",
	"./pause-at-work.svg": "8290",
	"./pause-at.svg": "85a9",
	"./playing-video-games-online.svg": "9ca5",
	"./sleep.svg": "4c1f",
	"./snack-at-university.svg": "3a8e",
	"./snack-time.svg": "c680",
	"./social-media.svg": "c6b6c",
	"./socialising.svg": "087b",
	"./studying.svg": "a1a6",
	"./watching-an-e-sport-game.svg": "6a23",
	"./watching-movie.svg": "478b",
	"./watching-series.svg": "5e66",
	"./working.svg": "9d64",
	"./workout.svg": "ba9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "216a";